module.exports = "https://cdn.hellotech.com/client-assets/doorbell_square_fffc5f718a6f5ff8a66bd8dfe6399421.jpg";